import { type ReactNode } from 'react';

import { RiInformationLine as InfoIcon } from '@remixicon/react';

import { ButtonIcon } from '@spotify-internal/encore-web';
import { Tooltip, TooltipRoot } from '@spotify-internal/encore-web/next';

type SectionInfoTooltipProps = {
  ariaLabel?: string;
  children: NonNullable<ReactNode>;
  iconSize?: number;
};

const SectionInfoTooltip = ({
  ariaLabel = 'More information',
  children,
  iconSize,
}: SectionInfoTooltipProps) => (
  <TooltipRoot>
    <ButtonIcon variant="tertiary" size="small" aria-label={ariaLabel}>
      <InfoIcon aria-hidden size={iconSize} />
    </ButtonIcon>
    <Tooltip>{children}</Tooltip>
  </TooltipRoot>
);

SectionInfoTooltip.displayName = 'Section.InfoTooltip';

export default SectionInfoTooltip;
